import React from 'react';

export default function AdminStatCard({ label, value, hint, valueClassName = '' }) {
  return (
    <div className="vx-sec-stat-card">
      <div className="vx-sec-stat-label">{label}</div>
      <div className={`vx-sec-stat-value ${valueClassName}`.trim()}>{value}</div>
      {hint ? <div className="vx-sec-stat-hint">{hint}</div> : null}
    </div>
  );
}
